import SearchVMBase from "Lib/Fs.SmartClient.Client/SearchVMBase";
import PagingCriteria from "Lib/Fs.Core.Data/PagingCriteria";
import SortingCriteria from "Lib/Fs.Core.Data/SortingCriteria";
import SortBy from "Lib/Fs.Core.Data/SortBy";
import { useView, autoinject, Container } from 'aurelia-framework'
import FsUtility from "Lib/Fs.SmartClient.Client/FsUtility";
import { fs } from "config/FsConfig";
import { Router } from 'aurelia-router'
import ManageUserGroupEditorVM from "./ManageUserGroupEditorVM";
import UserData01 from "../../../Core/Scripts/AppServiceContract/UserData01";
import ManageUserGroupMemberSearchParameter from "../../Scripts/AppServiceContract/ManageUserGroupMemberSearchParameter";
import UserCriteria01 from "../../../Core/Scripts/UserCriteria01";
import ManageUserGroupAppService from "../../Scripts/AppServiceContract/ManageUserGroupAppService";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./ManageUserGroupSearchView.html"))
export default class ManageUserGroupSearchVM extends SearchVMBase<ManageUserGroupEditorVM>{
  Code: string;
  Name: string;
  IsActive: boolean;
  IsActiveList: [];
  DefaultGroupCode: string;
  ItemsProvider: any;
  template: any;
  router: Router;

  constructor() {
    super(ManageUserGroupEditorVM);
    var self = this;
    this.router = Container.instance.get(Router);
    //var list = FsUtility.GetEnumTranslateList("IsActive", "EBill");
    //list.unshift({ Value: null, Name: "" });

    this.IsSearchAfterSave = true;
    this.IsClearSelectionAfterSave = true;
    this.Search();
  }

  getTemplate(e: any) {
    var key = e.target.data('title');
    this.CurrentItem.ErrorList = this.CurrentItem.getValidateErrors(key);
    return () => this.template.template
  }

  SearchItems(searchCallback: (result: UserData01[]) => void, sortingCriteria: SortingCriteria, pagingCriteria: PagingCriteria) {
    var self = this;

    var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;

    var criteria = new ManageUserGroupMemberSearchParameter();
    criteria = this.CreateCriteria();
    criteria.SortingCriteria = sortingCriteria;
    criteria.PagingCriteria = pagingCriteria;

    service.Find(criteria)
      .done((result) => {
        searchCallback(result);
      }).fail(FsUtility.CommonErrorHandler);
  }

  PrepareDefaultSortingCriteria(sortingCriteria: SortingCriteria) {
    var sortBy = new SortBy();
    sortBy.Direction = 0;
    sortBy.Name = "Code";
    sortingCriteria.push(sortBy);
  }

  CountItems(countCallback: (result: number) => void) {
    var self = this;
    var req = self.CreateCriteria();

    if (!this.CheckCriteriaEquals(req.Criteria)) {
      this.SearchCriteria = req.Criteria;
      var service = Container.instance.get(ManageUserGroupAppService) as ManageUserGroupAppService;
      service.Count(req.Criteria)
        .done((result) => {
          countCallback(result)
        }).fail(FsUtility.CommonErrorHandler);
    } else {
      countCallback(this.ItemCount);
    }
  }

  SearchCriteria: UserCriteria01;

  CheckCriteriaEquals(searchCriteria: UserCriteria01) {
    if (this.SearchCriteria == null) return false;
    return JSON.stringify(this.SearchCriteria) == JSON.stringify(searchCriteria);
  }

  CreateCriteria(): ManageUserGroupMemberSearchParameter {
    var req = new ManageUserGroupMemberSearchParameter();
    var cri = new UserCriteria01();
    cri.Code = $.trim(this.Code);
    cri.Name = $.trim(this.Name);
    //cri.isActive = this.IsActive == null || this.IsActive == "" ?
    //    null : this.IsActive == EBillEnum.IsActive.Active ? true : false;
    cri.IsGroup = true;
    req.Criteria = cri;
    return req;
  }

  RemoveCommand(editorVM: ManageUserGroupEditorVM) {
    super.RemoveCommand(editorVM);
  }

  Clear(): void {
    this.Code = null;
    this.Name = null;
    this.IsActive = null;
  }

  AddCommand() {
    window.location.href = fs.Config.UserGroupDetailUrl;
  }

}
